import { render } from "./singlebusinesslist.vue?vue&type=template&id=fa4daa5c"
import script from "./singlebusinesslist.vue?vue&type=script&lang=js"
export * from "./singlebusinesslist.vue?vue&type=script&lang=js"

import "./singlebusinesslist.vue?vue&type=style&index=0&id=fa4daa5c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__